import styled from 'styled-components'
import { font, spacing, colors } from '@chegg-ui/theme'
import { ContainerProps, ProgressBarSplitProps } from './types'

export const ProgressBarContainer = styled.div`
  padding: ${spacing.px16} ${spacing.px24};
`

export const ProgressBarHeading = styled.p`
  font-weight: ${font.weight.bold};
  font-size: ${font.size.px18};
  line-height: ${spacing.px24};
`

export const ProgressLine = styled.div`
  width: 100%;
  height: ${spacing.px8};
  border-radius: ${spacing.px64};
`
export const ProgressLineStatus = styled.p`
  font-weight: 400;
  font-size: ${font.size.px12};
  line-height: ${spacing.px16};
  letter-spacing: 0.3px;
  color: ${colors.grey600};
`

export const ProgressLineStatusArea = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${spacing.px12} 0;
`

export const Container = styled.div<ContainerProps>`
  position: relative;
  width: 100%;
  height: ${spacing.px8};
  border: 1px;
  border-radius: ${spacing.px16};
  background-color: ${({ defaultColor }) =>
    defaultColor || `${colors.grey100}`}; /* Default background color */
`

export const ProgressBarSplit = styled.div<ProgressBarSplitProps>`
  position: absolute;
  height: 100%;
  width: ${(props) => props.progressBarPercentage}%;
  border: 1px;
  border-radius: ${spacing.px16};
  background-color: ${({ progressBarColor }) =>
    progressBarColor || `${colors.grey400}`}; /* Color for the progressBar portion */
`
